export function GoldenLayoutID(componentId: string) {}

export enum GLComponentAlertStatus {
  /* IMPORTANT: if you change the enum, update the golden-layout-popout.html class binding */
  NONE,
  ALERT, // ALERT_ONLY
  ALERT_FLASH, // FLASH
  HCO,
  HCO_FLASH,
  SCO,
  SCO_FLASH,
}

export interface GoldenLayoutComponent {
  /**
   * Called when a component is first created from a component factory. Any data associated with
   * the action initiating the action will be passed on as data parameter.
   *
   * @param data see GLPopoutConfiguration.data
   */
  glInit?(data: any, container: any, state: any): void | PromiseLike<void>;

  /**
   * Called on an existing component to update its configuration data
   * @param data the new configuration data
   */
  glUpdate?(data: any): void | PromiseLike<void>;

  /**
   * GoldenLayoutServiceProfileConfig
   */
  glServiceProfileConfig?(): GoldenLayoutServiceProfileConfig;

  /**
   * modifies glServiceProfileConfig() behavior:
   *  saves config of service iteself if this is false
   *  saves config of service+singleton component's getComponentConfiguration() if this is true
   */
  glComponentIsSingleton?(): boolean;

  /**
   * optional identifier used by blotters
   */
  blotterId?: string;

  /**
   * Called when a component is opened in a popup or transferred to a popup container
   */
  undocked?(event: any): void;

  /**
   * Called when a component is opened or docked into a golden layout container
   */
  docked?(event: any): void;

  /**
   * Called when a resize occurs on the popup container
   */
  resize?(event: any): void;

  /**
   * Called when a resize occurs while the component is docked
   */
  resizeDocked?(event: any): void;

  /**
   * Save component state into an object in order to be restored later
   * with a call to restoreFromConfiguration
   */
  getComponentConfiguration?(): any;

  /**
   * Restore the state of the component from serialized data, obtained
   * by a call to getComponentConfiguration method
   */
  restoreFromConfiguration?(data: any);

  /**
   * Invoked when component is activated while docked in golden layout
   */
  componentActivated?();

  /**
   * Invoked when component is deactivated while docked in golden layout
   */
  componentDeactivated?();

  /**
   * Invoked to check if the tab above the component should flash (expanded to multiple states for bmark summary)
   */
  getAlertStatus?(): GLComponentAlertStatus;

  /**
   * Number to be displayed in component badge
   */
  getBadgeNumber?(): number;

  /**
   * return false to supress closing
   */
  onClose?(): boolean;

  /**
   * trigger repaint / recalculate layout based on dropped position
   */
  onDropped?(): void;

  /**
   * persist global state for a popout on a per component-tag-name basis from parent's
   * embeddedComponentConfig.data (saved via JSON / all enumerable keys)
   *
   * Doesn't work with first class components like blotters or find -dc
   */
  persistEmbeddedComponentConfigData?: boolean;

  /**
   * if the layout of the component has changed and you want to persist it before the window closes
   */
  setLayoutUpdatedCallback?(callBack: any): void;
}

/**
 *  this is suggested for use with singletons for example bfx-blotter-inbox
 */
export interface GoldenLayoutServiceProfileConfig {
  /**
   * return false to skip getServiceProfileConfig/setServiceProfileConfig calls
   */
  glServiceProfileConfig(): GoldenLayoutServiceProfileConfig;

  /**
   * configuration of the service itself
   * see GoldenLayoutComponent.getComponentConfiguration for component
   */
  getServiceConfiguration(): object;

  /**
   * configuration of the service itself
   */
  setServiceConfiguration(config: object): void;

  /**
   * tab identifier for the component. This is used to match with tabs
   * will need to update on tab creation (for titles and filters)
   */
  getTabIdentifier?(): string;
}
